import React from 'react';
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Button,
} from '@nextui-org/react';
import { MdOutlineEdit, MdDeleteOutline } from 'react-icons/md';
import { User } from 'common/src/utils/types';
import useUserStore from '../../../store/useUserStore';

interface TeamTableProps {
  users: User[];
  onEdit: (user: User) => void;
  onDelete: (user: User) => void;
}

const TeamTable: React.FC<TeamTableProps> = ({ users, onEdit, onDelete }) => {
  const { userProfile } = useUserStore();
  return (
    <Table aria-label='Users table' removeWrapper>
      <TableHeader>
        <TableColumn>Name</TableColumn>
        <TableColumn>Email</TableColumn>
        <TableColumn>Phone Number</TableColumn>
        <TableColumn>Role</TableColumn>
        <TableColumn>Actions</TableColumn>
      </TableHeader>
      <TableBody>
        {users.map((user) => (
          <TableRow key={user.id}>
            <TableCell>
              {user.first_name} {user.last_name}
            </TableCell>
            <TableCell>{user.email}</TableCell>
            <TableCell>{user.phone_number}</TableCell>
            <TableCell>{user.role.join(', ')}</TableCell>
            <TableCell>
              <Button
                onPress={() => onEdit(user)}
                isIconOnly
                className='bg-white'
              >
                <MdOutlineEdit size={20} color='#000080' />
              </Button>
              <Button
                isIconOnly
                onPress={() => onDelete(user)}
                className='bg-white'
                isDisabled={user.id === userProfile?.id}
              >
                <MdDeleteOutline size={20} color='#8B0000' />
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default TeamTable;
